export enum CompanyProfileModeEnum {
  SANDBOX = 'SANDBOX',
  LIVE = 'LIVE'
}
